import { Container } from './styles'

export function Footer() {
  const currentYear = new Date().getFullYear()
  
  return (
    <Container className="footer">
      <p>&copy; {currentYear} Kirti Kamal. All rights reserved.</p>
    </Container>
  )
}
